export const URLS = {
  HOME: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  RESET_PASSWORD: '/reset-password',
  LOAN_DETAILS: '/loan-details/:id',
  NEW_APPLICATION: '/new-application',
  FORGOT_PASSWORD: '/forgot-password',
};
